export const Constants = {
  TAG_NAME: 'pop-literature-component',
  MORE_LITERATURES_ID: '#more-literatures',
  DISPLAYED_LITERATURES_ID: '#displayed-literatures',
  MORE_POPOVER_ID: '#more-popover',
  MORE_POPOVER_BUTTON_ID: '#more-popover-button',
  BEACON_BUTTON: 'beacon-button',
  ARIA_EXPANDED: 'aria-expanded',
  BLANK: '_blank',
  BUTTON: 'button',
  TRUE: 'true',
  DATA_RANK: 'data-rank',
} as const;
